import {SessionStorageKey, getFromSessionStorage, setInSessionStorage} from "../sessionStorage";
import {useSessionStorageItem} from "./useBrowserStorage";

export const setTrafficId = (id: string) => setInSessionStorage(SessionStorageKey.TrafficId, id);

export const getTrafficId = () => getFromSessionStorage(SessionStorageKey.TrafficId);

export const useTrafficId = () => useSessionStorageItem(SessionStorageKey.TrafficId);
